export default __webpack_public_path__ + "static/media/404_error.4f3d150e.svg";